import { render, staticRenderFns } from "./AddForwarderModal.vue?vue&type=template&id=18698f48&scoped=true"
import script from "./AddForwarderModal.vue?vue&type=script&lang=js"
export * from "./AddForwarderModal.vue?vue&type=script&lang=js"
import style0 from "./AddForwarderModal.vue?vue&type=style&index=0&id=18698f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18698f48",
  null
  
)

export default component.exports